<template>
  <b-modal :active="isEditingUser" has-modal-card :on-cancel="handleClose">
    <div class="edit-user modal-content">
      <b-loading v-if="users.loadingSelected" active :is-full-page="false" />
      <mc-error-layout
        v-else-if="users.selectError"
        message="Failed to load User"
        :retry-fn="() => loadUser(userId)"
      />
      <div v-else class="box">
        <header class="title is-5">Edit User</header>
        <form class="edit-user__form" @submit.prevent="updateUserHandler">
          <b-field label="Email">
            <b-input
              v-model="users.selected.email"
              icon="at"
              placeholder="Email"
              required
              type="email"
            />
          </b-field>
          <mc-mobile-input
            v-model="users.selected.phoneNumber"
          ></mc-mobile-input>
          <b-field label="Child Name">
            <b-input
              v-model="users.selected.childName"
              icon="account"
              placeholder="Child Name"
              required
              type="text"
            />
          </b-field>
          <b-field label="Guardian Name">
            <b-input
              v-model="users.selected.guardianName"
              icon="account"
              placeholder="Guardian Name"
              required
              type="text"
            />
          </b-field>
          <b-button
            class="is-fullwidth"
            :loading="users.submitting"
            native-type="submit"
            type="is-primary"
          >
            Update
          </b-button>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import pick from 'lodash/pick';

export default {
  data: function() {
    return {
      isModalOpen: false,
      mobileNo: ''
    };
  },
  props: {
    isEditingUser: Boolean,
    userId: String
  },
  computed: {
    ...mapState(['users'])
  },
  methods: {
    ...mapActions('users', ['updateUser']),
    handleClose() {
      this.$emit('close');
    },
    async updateUserHandler() {
      this.loading = true;
      try {
        const editedUser = pick(this.users.selected, [
          'id',
          'email',
          'guardianName',
          'childName',
          'phoneNumber'
        ]);
        await this.updateUser(editedUser);
        this.handleClose();
        this.$buefy.toast.open({
          message: 'Update Sucessful',
          type: 'is-success'
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: e.message,
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.edit-user {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
